/**
 * serviceWorkerRegistration.js
 * Path: frontend/src/serviceWorkerRegistration.js
 * Description: Rejestracja service workera dla trybu PWA w buildzie produkcyjnym.
 * Related: src/index.js, public/service-worker.js
 */

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  if (!("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((error) => {
        console.error("Service worker registration failed", error);
      });
  });
}
